import { FC } from "react";

import { Heading, HStack, Text, VStack, Image, OrderedList, ListItem, Box } from "@chakra-ui/react";
import { formatVariables } from "utils/helper";

const StepsBox: FC<{ host: string; variables: string[]; steps: string[] }> = ({
  host,
  variables,
  steps,
}) => {
  return (
    <VStack
      bg="#F2F2F7"
      px={6}
      pt={4}
      pb={4}
      borderRadius={16}
      maxWidth="400px"
      width="calc(100% - 24px)"
      spacing={2}
      left="50%"
      right="12px"
    >
      <HStack width="100%">
        <Image src="/icons/steps.svg" alt="steps" objectFit="contain" borderRadius="16px" />
        <Heading as="h2" fontSize="18px" lineHeight="19px" fontWeight={500} color={"#1D2126"}>
          What do I need to do?
        </Heading>
      </HStack>

      <Box w={"100%"}>
        <OrderedList width="100%">
          {steps.length > 0 ? (
            <>
              {steps.map((step, index) => (
                <ListItem key={index}>
                  <Text
                    color="gray.600"
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight={400}
                    width="100%"
                    my={2}
                  >
                    {step}
                  </Text>
                </ListItem>
              ))}
            </>
          ) : (
            <>
              <ListItem>
                <Text
                  color="gray.600"
                  fontSize="16px"
                  lineHeight="19px"
                  fontWeight={400}
                  width="100%"
                  my={2}
                >
                  Log-in to your {host} account
                </Text>
              </ListItem>
              <ListItem>
                <Text
                  color="gray.600"
                  fontSize="16px"
                  lineHeight="19px"
                  fontWeight={400}
                  width="100%"
                  my={2}
                >
                  After logging in, navigate to the section where {formatVariables(variables)}{" "}
                  {variables.length > 1 ? "are" : "is"} displayed
                </Text>
              </ListItem>
            </>
          )}
        </OrderedList>
      </Box>
    </VStack>
  );
};

export default StepsBox;
